<template>
  <el-dialog
    class="schedule-entrance-test-dialog entrance-block-consult-dialog"
    :visible="visible"
    width="480px"
    :show-close="false"
    :close-on-click-modal="false"
    append-to-body
    @close="handleClose"
  >
    <div
      slot="title"
      class="schedule-entrance-test-dialog__header d-flex align-items-center justify-content-between px-4 py-3"
    >
      <h3 class="font-weight-bold mb-0">Thông báo</h3>
      <button
        type="button"
        class="schedule-entrance-test-dialog__close btn p-0 d-inline-flex align-items-center justify-content-center"
        @click="handleClose"
      >
        <i class="el-icon-close"></i>
      </button>
    </div>

    <div class="schedule-entrance-test-dialog__body bg-white px-4 pt-4 pb-4">
      <p class="entrance-block-consult-dialog__text mb-0">
        {{ message }}
      </p>
    </div>

    <div slot="footer" class="schedule-entrance-test-dialog__footer d-flex justify-content-end">
      <el-button class="schedule-entrance-test-dialog__cancel" :disabled="loading" @click="handleClose">
        Đóng
      </el-button>
      <el-button
        class="schedule-entrance-test-dialog__confirm"
        type="primary"
        :loading="loading"
        :disabled="loading"
        @click="$emit('view')"
      >
        Xem chi tiết
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "EntranceBlockConsultDialog",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: "Chưa thể đặt lịch tư vấn do khách hàng đang trong quá trình kiểm tra năng lực đầu vào"
    }
  },
  methods: {
    handleClose() {
      if (this.loading) return;
      this.$emit("update:visible", false);
    }
  }
};
</script>

<style src="./entrance/entrance-dialog.css"></style>

<style scoped>
.entrance-block-consult-dialog__text {
  color: #3f3b48;
  font-size: 14px;
  line-height: 1.5;
  overflow-wrap: break-word !important;
  word-break: normal !important;
}
</style>
